export default "__VITE_PUBLIC_ASSET__b51c2586__"